export default function Stats() {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Statistiques</h1>
        <p className="mt-2 text-gray-600">Analysez vos performances et KPIs</p>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-500">Page en cours de développement...</p>
      </div>
    </div>
  );
}
